import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataProcessingService } from './data-prcessing.service';

import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Card, NewUserCard } from '../interfaces/cards.interface';
import { Observable } from 'rxjs';
import { SearchResult } from '../interfaces/search.interface';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class searchService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('search');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  search(searchTxt: string): Observable<Array<SearchResult>> {
    return this.http.get<Array<SearchResult>>(`${this.apiUrl}/${searchTxt}`);
  }

}
